module.exports = __webpack_public_path__ + "img/t2-27.d398d9d4.svg";